import { ToggleButton, ToggleButtonProps } from "@mui/material";
import { Control, Controller, FieldValues, Path, useFormContext } from "react-hook-form";

type FormToggleButtonProps<IFormValues extends FieldValues = FieldValues> = Omit<ToggleButtonProps, 'value' | 'selected'> & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>,
    shouldUnregister?: boolean
}

const FormToggleButton = <IFormValues extends FieldValues = FieldValues>({
    name,
    control,
    shouldUnregister,
    ...props
}: FormToggleButtonProps<IFormValues>) => {

    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            shouldUnregister={shouldUnregister}
            render={({ field, formState }) =>
                <ToggleButton
                    {...props}
                    value={name}
                    selected={field.value}
                    onChange={() => {
                        field.onChange(!field.value);
                    }}
                    disabled={props.disabled ?? formState.isSubmitting}
                >
                    {props.children}
                </ToggleButton>
            }
        />
    );
};

export default FormToggleButton;